import styles from '@/styles/Info.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Hero from '@/components/common/Hero/Hero'
import { useTranslation } from 'next-i18next'
import { getPageTitle } from '@/utils/helpers'
import classNames from 'classnames'
import ContactForm from '@/components/common/ContactForm/ContactForm'
import ContactInfo from '@/components/common/ContactInfo/ContactInfo'

type Props = {}

const Contact = (props: Props) => {
  const { t } = useTranslation('contact')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('title'))}</title>
      </Head>
      <Hero />
      <main className={classNames(styles.info, styles.split)}>
        <div>
          <h1>{t('title')}</h1>
          <p>
            Statusfälgar i Sverige AB<br />
            Arkitektvägen 4<br />
            14945 Nynäshamn, Sverige<br />
          </p>
          <ContactInfo />
          <div className={styles.ourOpeningHours}>
            <h3>{t('ourOpeningHours')}</h3>
            {t('monday')} 07.30-16.00<br />
            {t('tuesday')} 07.30-16.00<br />
            {t('wednesday')} 07.30-16.00<br />
            {t('thursday')} 07.30-16.00<br />
            {t('friday')} 07.30-15.30<br />
          </div>
        </div>
        <div>
          <ContactForm
            showLicensePlate={true}
          />
        </div>
      </main>
    </BaseLayout>
  )
}

export default Contact

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'contact',
      'footer',
    ])),
  },
})